import { FC, Fragment, useMemo } from 'react';
import styled from 'styled-components';
import { linkifyText } from '../utils/linkify';

const Anchor = styled.a`
  color: inherit;
  text-decoration: underline;
  overflow-wrap: anywhere;

  &:hover {
    color: inherit;
    opacity: 0.8;
  }
`;

// Renders plain message text with http(s) links clickable; parts are React nodes, so no HTML is ever injected.
export const LinkifiedText: FC<{ text: string }> = ({ text }) => {
  const parts = useMemo(() => linkifyText(text), [text]);

  return (
    <>
      {parts.map((part, index) =>
        part.type === 'link' ? (
          <Anchor key={index} href={part.href} target="_blank" rel="noopener noreferrer">
            {part.value}
          </Anchor>
        ) : (
          <Fragment key={index}>{part.value}</Fragment>
        ),
      )}
    </>
  );
};
